import { IDropPropertyTemplateModalData } from "./components/DropPropertyTemplateModal";
import useReadOnlyModeGuard from "@rf-hooks/useReadOnlyModeGuard";
const useDropProperty = () => {
  const { guardReadOnlyAction } = useReadOnlyModeGuard();
  const handleDropProperty = (arg: IDropPropertyTemplateModalData) => {
    guardReadOnlyAction("dar de baja propiedad", "use-drop-property");
  };

  return {
    handleDropProperty
  };
};

export default useDropProperty;
